@if (mediaList != null && mediaList.length > 0) {
    <div class="EFCarousel {{isFullscreen ? 'EFCarousel--Fullscreen' : ''}}" role="region" [attr.aria-roledescription]="'carousel'" [attr.aria-label]="'experience-finder.a11y.carousel-region' | locTranslate" (click)="resetInactivity()">
        @if (mediaList.length > 1) {
            <button type="button" class="EFCarousel-ToggleAutoplay btn {{ isFullscreen ? 'btn-lg btn-link text-white' : 'btn-light m-2' }}" (click)="toggleAutoplay($event)" [attr.aria-pressed]="!isAutoplayPaused" [attr.aria-label]="(isAutoplayPaused ? 'experience-finder.a11y.carousel-play' : 'experience-finder.a11y.carousel-pause') | locTranslate">
                <i class="fa-regular {{ isAutoplayPaused ? 'fa-play' : 'fa-pause' }}" aria-hidden="true"></i>
            </button>
        }
        @if (!isFullscreen) {
            <button type="button" class="EFCarousel-ToggleFullscreen btn btn-light m-2" (click)="isFullscreen = !isFullscreen" [attr.aria-label]="'experience-finder.a11y.carousel-expand' | locTranslate">
                <i class="fa-regular fa-expand" aria-hidden="true"></i>
            </button>
        }
        @if (isFullscreen) {
            <button type="button" class="EFCarousel-ToggleFullscreen btn btn-lg btn-link text-white" (click)="isFullscreen = !isFullscreen" [attr.aria-label]="'experience-finder.a11y.carousel-collapse' | locTranslate">
                <i class="fa-regular fa-times" aria-hidden="true"></i>
            </button>
        }
        <div class="EFCarousel-Slides">
            <div>
                @for (media of mediaList; track media; let i = $index) {
                    <div [style.transform]="'translate(' + (-currentIndex * 100) + '%, 0%)'" [attr.aria-hidden]="i != currentIndex">
                        @if (media.type == 'image') {
                            <app-pg-image-autosize [src]="media.url" [fit]="(isFullscreen || media.fit == 'contain')  ? 'contain' : 'cover'" [alt]="'experience-finder.a11y.carousel-slide' | locTranslate:'index':(i + 1)"></app-pg-image-autosize>
                        }
                        @if (media.type == 'video') {
                            <div class="EFCarousel-Video">
                                <video [style.objectFit]="(isFullscreen || media.fit == 'contain') ? 'contain' : 'cover'" (click)="videoTogglePlay($event)" (play)="onVideoPlay($event)" (pause)="onVideoPause($event)" [attr.aria-label]="'experience-finder.a11y.video-play-pause' | locTranslate">
                                    <source src="{{media.url}}" type="video/mp4">
                                </video>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
        @if (mediaList.length > 1) {
            <div class="EFCarousel-Index" role="tablist">
                @for (media of mediaList; track media; let i = $index) {
                    <button type="button" class="btn btn-link text-white" role="tab" [attr.aria-selected]="i == currentIndex" (click)="currentIndex = i" [attr.aria-label]="'experience-finder.a11y.carousel-slide' | locTranslate:'index':(i + 1)">
                        <i class="{{i == currentIndex ? '' : 'opacity-50'}} fa fa-circle" aria-hidden="true"></i>
                    </button>
                }
            </div>
        }
    </div>
}
